/* unplugin-vue-components disabled */import script from "./honor-poster.vue?vue&type=script&setup=true&lang=js"
export * from "./honor-poster.vue?vue&type=script&setup=true&lang=js"

import "./honor-poster.vue?vue&type=style&index=0&id=1f9c37e6&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f9c37e6"]])

export default __exports__